<script lang="ts">
import { iIcon } from '@inscribe/signal';
import * as documentStates from '@/constants/documentStates';

export const DocumentCardImageType = {
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  LOADING: 'loading',
  DEFAULT: 'default',
};

export const DocumentCardImageSizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
};

export default {
  name: 'DocumentCard',
  components: {
    iIcon,
  },
  props: {
    document: {
      type: Object,
    },
    type: {
      type: String,
      default: DocumentCardImageType.DEFAULT,
    },
    size: {
      type: String,
      default: DocumentCardImageSizes.MEDIUM,
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {
      DocumentCardImageType,
      DocumentCardImageSizes,
      documentStates,
    };
  },
  computed: {
    documentHasThumbnail() {
      return (
        this.document?.urls?.thumbnail_small &&
        this.type !== DocumentCardImageType.LOADING &&
        !this.processing &&
        ![documentStates.PASSWORD_PROTECTED].includes(this.document?.state)
      );
    },
  },
  methods: {
    getThumbnailUrl() {
      return this.document?.urls?.thumbnail_small || '';
    },
  },
};
</script>

<template>
  <div
    :class="{
      loading: type === DocumentCardImageType.LOADING,
      accepted: type === DocumentCardImageType.ACCEPTED,
      rejected: type === DocumentCardImageType.REJECTED,
      default: type === DocumentCardImageType.DEFAULT,
      small: size === DocumentCardImageSizes.SMALL,
      medium: size === DocumentCardImageSizes.MEDIUM,
    }"
    class="document-image d-flex align-items-center justify-content-center i-px-9 i-radius-xl"
  >
    <div class="thumbnail d-flex align-items-center justify-content-center">
      <img class="img" v-if="documentHasThumbnail" :src="getThumbnailUrl()" />
      <i-icon
        v-else-if="
          [documentStates.PASSWORD_PROTECTED].includes(document?.state)
        "
        class="password-protected-icon"
        :size="24"
        color="var(--icon-error-subtle)"
        symbol="small-lock"
      />
      <i-icon
        v-else-if="documentStates.isErrorState(document?.state)"
        class="img error-icon"
        :size="24"
        color="var(--icon-error-subtle)"
        symbol="small_solid_alert_triangle"
      />
      <div
        v-else
        class="placeholder img d-flex align-items-center justify-content-center"
      ></div>
    </div>

    <!-- icon -->
    <i-icon
      v-if="
        [
          DocumentCardImageType.ACCEPTED,
          DocumentCardImageType.REJECTED,
        ].includes(type)
      "
      class="review-icon"
      :size="12"
      :symbol="
        type === DocumentCardImageType.ACCEPTED
          ? 'small-solid-check'
          : 'small-solid-delete'
      "
    />
  </div>
</template>

<style lang="scss" scoped>
.document-image {
  background: $light-neutral-30;
  height: 88px;
  width: 104px;
  position: relative;
  overflow: hidden;

  .thumbnail {
    .img {
      max-width: 48px;
      height: auto;
    }

    .placeholder {
      background: $white-base;
      width: 48px;
      height: 72px;
    }
  }

  &.small {
    height: 72px;
    .img {
      max-width: 44px;
      height: auto;
    }
  }

  &.accepted {
    background: $light-success-30;

    .review-icon {
      color: $light-success-90;
    }
  }
  &.rejected {
    background: $light-error-30;

    .review-icon {
      color: $light-error-90;
    }
  }

  .review-icon {
    position: absolute;
    bottom: 6px;
    right: 6px;
  }

  .error-icon {
    color: $light-error-90;
  }
}
</style>
